var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMotor = function SvgMotor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    d: "M6 12v4.5a6.5 6.5 0 0 0 6.5 6.5h.25A6.25 6.25 0 0 0 19 16.75V13.5a3 3 0 0 0-3-3h-1.75c-.69 0-1.25.56-1.25 1.25v0c0 .69.56 1.25 1.25 1.25h1.759c.271 0 .491.22.491.491v.633a.375.375 0 0 1-.375.376v0A3.125 3.125 0 0 0 13 17.625V19"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 5,
    x: 6,
    y: 9,
    stroke: "#333",
    rx: 1.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 5,
    x: 8.5,
    y: 9,
    stroke: "#333",
    rx: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "m14.434 10.563-2.283-6.108a1.25 1.25 0 1 1 2.342-.876l2.736 7.321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "m11.007 11.701 1.93-5.107m1.285-3.403.202-.535a1.25 1.25 0 0 1 2.339.883l-1.046 2.767-.123.327"
  })));
};
export default SvgMotor;